import React, { ReactElement, FormEvent } from 'react';

interface props {
    id: string,
    required?: boolean,
    isValid?: boolean,
    className?: string,
    value?: string | number | readonly string[],
    defaultValue?: string | number | readonly string[]
    onChange?: (e: FormEvent<HTMLInputElement>) => void,
    [key: string]: any,
}

const telPattern = `^[0-9-+\\s()]*$`; // eslint-disable-line quotes

const TelInput = ({ id, required, isValid, className, value, defaultValue, onChange, ...rest }: props): ReactElement => (
    <input
        id={id}
        className={`${className} bg-white text-paragraph text-dark`}
        type="tel"
        aria-required={required}
        aria-invalid={isValid === false}
        value={value}
        pattern={telPattern}
        defaultValue={defaultValue}
        onChange={onChange}
        autoComplete="tel"
        title="Only enter numbers, +, -, or ()"
        {...rest}
    />
);

TelInput.defaultProps = {
    required: false,
    className: undefined,
    isValid: false,
    value: undefined,
    defaultValue: undefined,
    onChange: undefined
};

export default TelInput;
